import type { Mission } from '../missions.ts'

export const nsf: Mission = {
  id: "nsf",
  name: "U.S. National Science Foundation",
  short: "NSF",
  call: "Science",
  kind: "independent",
  url: "https://www.nsf.gov/",
  established: 1950,
  palette: {
    primary: "#223a73",
    secondary: "#0076d6",
    accent: "#c9ab48",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nsf.gov/",
  },
  motif: "globe",
  mission: {
    text: "To promote the progress of science; to advance the national health, prosperity, and welfare; and to secure the national defense; and for other purposes.",
    url: "https://www.nsf.gov/about/history",
  },
  fact: {
    text: "NSF was established in 1950 when President Harry S. Truman signed the National Science Foundation Act of 1950.",
    url: "https://www.nsf.gov/about/history",
  },
  seal: {
    file: "public/seals/nsf.svg",
    source: "https://commons.wikimedia.org/wiki/File:NSF_logo.svg",
  },
  identifier: {
    about: "https://www.nsf.gov/about",
    accessibility: "https://www.nsf.gov/policies/accessibility",
    foia: "https://www.nsf.gov/policies/foia",
    noFear: "https://www.nsf.gov/od/ocr/no-fear-act",
    oig: "https://oig.nsf.gov/",
    performance: "https://www.nsf.gov/about/budget",
    privacy: "https://www.nsf.gov/policies/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/nsf-south-pole-night.jpg",
        small: "/media/nsf-south-pole-night-sm.jpg",
        alt: "Green aurora arcs over the buildings of Amundsen-Scott South Pole Station during the Antarctic night.",
        title: "Amundsen-Scott South Pole Station in the Antarctic night, July 2005",
        creator: "Chris Danals, National Science Foundation",
        source: "https://commons.wikimedia.org/wiki/File:Amundsen-Scott_marsstation_ray_h.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nsf-south-pole-aurora.jpg",
        small: "/media/nsf-south-pole-aurora-sm.jpg",
        alt: "Green curtains of the aurora australis above the snow-covered former geodesic dome at the South Pole.",
        title: "Amundsen-Scott South Pole Station dome under the aurora australis, May 2002",
        creator: "Jonathan Berry, National Science Foundation",
        source: "https://commons.wikimedia.org/wiki/File:Amundsen-Scott_dome_Aurora_1.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
